/* snc-product-card rating sync (moved from snippet; guarded so it runs once per page) */
(function () {
    'use strict';
    if (window.__sncCardRatingsInit) return;
    window.__sncCardRatingsInit = true;

    function updateCardRatings() {
      // Find all product card star elements
      const starContainers = document.querySelectorAll('.snc-stars[data-product-handle]');
      if (!starContainers.length) return;

      // Get body text for regex extraction
      const bodyText = document.body.innerText || document.body.textContent;

      // Extract overall rating from Judge.me widget if present
      let widgetRating = null;
      let widgetCount = null;

      // Look for "X.XX out of 5" pattern in Judge.me widget
      const ratingMatch = bodyText.match(/(\d+\.\d+)\s*out\s*of\s*5/i);
      if (ratingMatch) {
        const val = parseFloat(ratingMatch[1]);
        if (val >= 0 && val <= 5) widgetRating = val;
      }

      // Look for "Based on X reviews"
      const countMatch = bodyText.match(/Based on\s+(\d+)\s+reviews/i);
      if (countMatch) {
        widgetCount = parseInt(countMatch[1]);
      }

      // If we have widget data, update all cards (assuming same product or collection page)
      if (widgetRating && widgetRating > 0) {
        const ratingInt = Math.round(widgetRating);

        starContainers.forEach(function (container) {
          const currentRating = parseInt(container.dataset.rating) || 0;

          // Only update if we have better data (Judge.me > Shopify metafield > default)
          if (widgetRating > currentRating || currentRating === 0) {
            let starsHtml = '';
            for (let i = 1; i <= 5; i++) {
              if (i <= ratingInt) {
                starsHtml += '<span class="snc-star" aria-hidden="true">★</span>';
              } else {
                starsHtml += '<span class="snc-star snc-star--empty" aria-hidden="true">★</span>';
              }
            }
            container.innerHTML = starsHtml;
            container.setAttribute('aria-label', 'Rating: ' + ratingInt + ' out of 5 stars');
            container.dataset.rating = ratingInt;
            if (widgetCount) container.dataset.count = widgetCount;
          }
        });
      }
    }

    // Wait for Judge.me to load and update
    function waitForJudgeMe() {
      // Try immediately
      updateCardRatings();

      // Retry a few times as Judge.me loads
      let attempts = 0;
      const maxAttempts = 15;

      const interval = setInterval(function () {
        attempts++;

        // Check if Judge.me widget exists
        if (document.querySelector('.jdgm-rev-widg, .jdgm-widget')) {
          updateCardRatings();
        }

        // Stop after max attempts
        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 400);
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForJudgeMe);
    } else {
      waitForJudgeMe();
    }
  })();
